import { lazy } from "react";

const DashboardRoutes = [
  // Dashboards
  {
    path: "/apps/dashboard/getting-started",
    component: lazy(() => import("../../views/dashboard/admin-setup")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/dashboard/company",
    component: lazy(() => import("../../views/dashboard/login-company")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/dashboard/analytics",
    component: lazy(() => import("../../views/dashboard/analytics")),
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/dashboard/ecommerce",
    component: lazy(() => import("../../views/dashboard/ecommerce")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/dashboard/operation",
    component: lazy(() => import("../../views/dashboard/operation-dashboard")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/dashboard/private",
    component: lazy(() => import("../../views/dashboard/private-dashboard")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/dashboard/client-dashboard",
    component: lazy(() => import("../../views/dashboard/client-dashboard")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
];
export const WorkRouter = [
  // Dashboards
  // {
  //   path: '/work/contrack',
  //   component: lazy(() => import('../../views/dashboard/analytics')),
  //   meta: {
  //     action: 'read',
  //     resource: 'ACL'
  //   }
  // },
  {
    path: "/apps/settings/apps-workSpace",
    className: "apps-workSpace-application",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/app-workSpace")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/point",
    component: lazy(() => import("../../views/apps/ecommerce/point")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/hr/employees/:employeesId",
    component: lazy(() => import("../../views/apps/ecommerce/hr/employees")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/employees/edit/:employeesId",
    component: lazy(() => import("../../views/apps/ecommerce/hr/employees")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/hr/all-employees",
    component: lazy(() => import("../../views/apps/ecommerce/hr/employees")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/departments",
    component: lazy(() => import("../../views/apps/ecommerce/hr/department")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/designations",
    component: lazy(() => import("../../views/apps/ecommerce/hr/designation")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/all-attendance",
    component: lazy(() => import("../../views/apps/ecommerce/hr/attendance")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/hr/all-leaves",
    component: lazy(() => import("../../views/apps/ecommerce/hr/leaves")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/all-holidays",
    component: lazy(() => import("../../views/apps/ecommerce/hr/holiday")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/notes/create",
    component: lazy(() => import("../../views/apps/ecommerce/work/notes")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/work/all-notes",
    component: lazy(() => import("../../views/apps/ecommerce/work/notes")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  // Asset Module
  {
    path: "/apps/hr/all-assets",
    component: lazy(() => import("../../views/apps/ecommerce/hr/assets")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/assets/edit/:assetId",
    component: lazy(() => import("../../views/apps/ecommerce/hr/assets")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/hr/assets/detail/:assetId",
    component: lazy(() => import("../../views/apps/ecommerce/hr/assets")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/work/view-project/:projectId",
    component: lazy(() => import("../../views/apps/view-project")),
    className: "ecommerce-application",
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/apps/work/project/:projectId",
    component: lazy(() => import("../../views/apps/ecommerce/work/project")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/all-projects",
    component: lazy(() => import("../../views/apps/ecommerce/work/project")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/my-projects",
    component: lazy(() => import("../../views/apps/ecommerce/work/project")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  {
    path: "/apps/work/projects/edit-project/:projectId",
    className: "kanban-application",
    component: lazy(() => import("../../views/apps/ecommerce/work/project")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/all-notes",
    component: lazy(() => import("../../views/apps/ecommerce/work/notes")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },

  // {
  //   path: "/work/task-board",
  //   className: "kanban-application",
  //   component: lazy(() =>
  //     import("../../views/apps/ecommerce/work/task-board-kanban")
  //   ),
  //   exact: true,
  //   meta: {
  //     action: "read",
  //     resource: "ACL",
  //   },
  // },
  // {
  //   path: '/apps/work/tasks?page=:numberPage',
  //   className: 'kanban-application',
  //   component: lazy(() => import('../../views/apps/ecommerce/work/tasks')),
  //   exact: true,
  //   meta: {
  //     navLink: "/apps/work/tasks",
  //     action: 'read',
  //     resource: 'ACL'
  //   }
  // },
  {
    path: "/apps/work/tasks/:taskId",
    // className: 'kanban-application',
    component: lazy(() => import("../../views/apps/ecommerce/work/tasks")),
    exact: true,
    meta: {
      // navLink: "/apps/work/tasks",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/tasks/edit-task/:taskId",
    // className: 'kanban-application',
    component: lazy(() => import("../../views/apps/ecommerce/work/tasks")),
    exact: true,
    meta: {
      // navLink: "/apps/work/tasks",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/all-tasks",
    component: lazy(() => import("../../views/apps/ecommerce/work/tasks")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/my-tasks",
    component: lazy(() => import("../../views/apps/ecommerce/work/tasks")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/contracts/edit/:contractId",
    component: lazy(() => import("../../views/apps/ecommerce/work/contracts")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/all-contracts",
    component: lazy(() => import("../../views/apps/ecommerce/work/contracts")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/discussion",
    component: lazy(() => import("../../views/apps/ecommerce/work/discussion")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/milestones/detail/:milestonesId",
    className: "kanban-application",
    component: lazy(() => import("../../views/apps/ecommerce/work/milestones")),
    exact: true,
    meta: {
      navLink: "/apps/work/milestones",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/milestones/edit/:milestonesId",
    className: "kanban-application",
    component: lazy(() => import("../../views/apps/ecommerce/work/milestones")),
    exact: true,
    meta: {
      navLink: "/apps/work/milestones",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/milestones",
    component: lazy(() => import("../../views/apps/ecommerce/work/milestones")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/my-milestones",
    component: lazy(() => import("../../views/apps/ecommerce/work/milestones")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/work/task/:idMilestone",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/milestone/milestone-board/task-by-milestone")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/work/milestones/:idProject",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/milestone/milestone-board")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/work/milestones",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/milestone")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/work-app/:idApp",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/work-app/portfolioDetail")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/work-app",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/work-app")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/team",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/team")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/help-center",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/help-center")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/profile",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/profile")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/service",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/services")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/client-view/setup-wizard",
    component: lazy(() => import("../../views/apps/ecommerce/cmsmart/client-view/wizard-client")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/clients/all-estimates",
    component: lazy(() => import("../../views/apps/ecommerce/work/Estimates")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/clients/all-estimates/edit/:milestonesId",
    className: "kanban-application",
    component: lazy(() => import("../../views/apps/ecommerce/work/Estimates")),
    exact: true,
    meta: {
      navLink: "/apps/clients/all-Estimates",
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/timelogs/edit/:timelogId",
    component: lazy(() => import("../../views/apps/ecommerce/work/time-logs")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/work/all-timelogs",
    component: lazy(() => import("../../views/apps/ecommerce/work/time-logs")),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/estimates",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/estimates")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/estimates/:alias",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/estimates")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/invoices/view/:id",
    className: "ecommerce-application",
    component: lazy(() => import("../../views/apps/view-invoice")),
    meta: {
      action: "read",
      resource: "ACL",
      publicRoute: true,
      menuHidden: true,
    },
  },
  {
    path: "/apps/finance/all-invoices/edit/:invoicesId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/invoices")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/all-invoices/detail/:invoicesId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/invoices")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/all-invoices",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/invoices")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/payments/detail/:paymentId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/payments")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/payments/edit/:paymentId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/payments")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/all-payments",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/payments")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/invoice-recurring/edit/:invoiceRecurringId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/recurring-invoice")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/invoice-recurring",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/recurring-invoice")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/all-expenses/detail/:expensesId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/expenses")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/all-expenses/edit/:expensesId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/expenses")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/all-expenses",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/expenses")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/expenses-recurring/edit/:expensesRecurringId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/expenses-recurring")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/finance/expenses-recurring",
    component: lazy(() =>
      import("../../views/apps/ecommerce/finance/expenses-recurring")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  // {
  //   path: "/finance/all-credit-notes",
  //   component: lazy(() =>
  //     import("../../views/apps/ecommerce/finance/credit-notes")
  //   ),
  //   exact: true,
  //   meta: {
  //     action: "read",
  //     resource: "ACL",
  //   },
  // },
  {
    path: "/apps/faq/all-knowledge/:faqId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/faq")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/faq/all-knowledge/edit-faq/:faqId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/faq")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/faq/all-knowledge",
    component: lazy(() =>
      import("../../views/apps/ecommerce/faq")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
];
export const LeadRouter = [
  {
    path: "/apps/leads/edit-lead/:leadId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/leads/listing-lead")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/leads/:leadId",
    component: lazy(() =>
      import("../../views/apps/ecommerce/leads/listing-lead")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  {
    path: "/apps/all-leads",
    component: lazy(() =>
      import("../../views/apps/ecommerce/leads/listing-lead")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  // {
  //   path: "/apps/project-leads",
  //   component: lazy(() => import("../../views/apps/ecommerce/leads/project")),
  //   exact: true,
  //   meta: {
  //     action: "read",
  //     resource: "ACL",
  //   },
  // },
  {
    path: "/apps/leads-source",
    component: lazy(() =>
      import("../../views/apps/ecommerce/leads/leads-source")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
  // {
  //   path: "/apps/activities",
  //   component: lazy(() => import("../../views/apps/ecommerce/leads/follow-up")),
  //   exact: true,
  //   meta: {
  //     action: "read",
  //     resource: "ACL",
  //   },
  // },
];
export const ReportsRouter = [
  {
    path: "/apps/report/lead-report",
    component: lazy(() =>
      import("../../views/apps/ecommerce/reports/lead-report")
    ),
    exact: true,
    meta: {
      action: "read",
      resource: "ACL",
    },
  },
];

export default DashboardRoutes;
